import React from 'react';
import { FileText, Mail, Phone, MapPin, Clock, AlertTriangle, Scale, DollarSign, Users, Shield, Hammer, Building, CheckCircle } from 'lucide-react';
import { Helmet } from 'react-helmet';

const TermsConditions = () => {
  return (
    <>
    <Helmet>
                    <title>Terms of Services</title>
                  </Helmet>
    <div className="terms-conditions">
      <style jsx>{`
        .terms-conditions {
          min-height: 100vh;
          background: linear-gradient(135deg, #EEEEEE 0%, #F5F5F5 100%);
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          color: #222831;
          line-height: 1.6;
        }

        .header {
          background: linear-gradient(135deg, #222831 0%, #393E46 100%);
          color: #EEEEEE;
          padding: 4rem 0;
          text-align: center;
          position: relative;
          overflow: hidden;
        }

        .header::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><polygon points="50,20 80,80 20,80" fill="rgba(255,211,105,0.1)"/></svg>');
          background-size: 60px 60px;
          animation: float 25s infinite linear;
        }

        @keyframes float {
          0% { transform: translateY(0px) translateX(0px) rotate(0deg); }
          50% { transform: translateY(-15px) translateX(8px) rotate(180deg); }
          100% { transform: translateY(0px) translateX(0px) rotate(360deg); }
        }

        .header-content {
          position: relative;
          z-index: 2;
          max-width: 800px;
          margin: 0 auto;
          padding: 0 2rem;
        }

        .company-name {
          font-size: 3rem;
          font-weight: 700;
          margin-bottom: 1rem;
          color: #FFD369;
          text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
        }

        .company-tagline {
          font-size: 1.2rem;
          margin-bottom: 2rem;
          opacity: 0.9;
        }

        .header-icon {
          width: 60px;
          height: 60px;
          color: #FFD369;
          margin-bottom: 1rem;
          filter: drop-shadow(0 4px 8px rgba(0,0,0,0.2));
        }

        .container {
          max-width: 1000px;
          margin: 0 auto;
          padding: 3rem 2rem;
        }

        .intro-section {
          background: white;
          border-radius: 20px;
          padding: 3rem;
          margin-bottom: 3rem;
          box-shadow: 0 10px 30px rgba(34, 40, 49, 0.1);
          border-left: 5px solid #FFD369;
          position: relative;
          overflow: hidden;
        }

        .intro-section::before {
          content: '';
          position: absolute;
          top: -50%;
          right: -50%;
          width: 100%;
          height: 200%;
          background: linear-gradient(45deg, transparent, rgba(255, 211, 105, 0.03), transparent);
          transform: rotate(45deg);
        }

        .intro-content {
          position: relative;
          z-index: 2;
        }

        .last-updated {
          background: #FFD369;
          color: #222831;
          padding: 0.5rem 1rem;
          border-radius: 25px;
          font-size: 0.9rem;
          font-weight: 600;
          display: inline-block;
          margin-bottom: 2rem;
        }

        .section {
          background: white;
          border-radius: 15px;
          padding: 2.5rem;
          margin-bottom: 2rem;
          box-shadow: 0 5px 20px rgba(34, 40, 49, 0.08);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          border: 1px solid rgba(255, 211, 105, 0.2);
        }

        .section:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(34, 40, 49, 0.12);
        }

        .section-header {
          display: flex;
          align-items: center;
          margin-bottom: 1.5rem;
          padding-bottom: 1rem;
          border-bottom: 2px solid #FFD369;
        }

        .section-icon {
          width: 28px;
          height: 28px;
          color: #FFD369;
          margin-right: 1rem;
          flex-shrink: 0;
        }

        .section-title {
          font-size: 1.5rem;
          font-weight: 700;
          color: #222831;
          margin: 0;
        }

        .section-content {
          color: #393E46;
          font-size: 1rem;
        }

        .section-content p {
          margin-bottom: 1rem;
        }

        .section-content ul, .section-content ol {
          margin: 1rem 0;
          padding-left: 1.5rem;
        }

        .section-content li {
          margin-bottom: 0.5rem;
          position: relative;
        }

        .section-content li::marker {
          color: #FFD369;
        }

        .highlight-box {
          background: linear-gradient(135deg, #FFD369, #FFE69A);
          color: #222831;
          padding: 1.5rem;
          border-radius: 10px;
          margin: 1.5rem 0;
          font-weight: 500;
          box-shadow: 0 4px 15px rgba(255, 211, 105, 0.3);
        }

        .warning-box {
          background: linear-gradient(135deg, #ff6b6b, #ff8e8e);
          color: white;
          padding: 1.5rem;
          border-radius: 10px;
          margin: 1.5rem 0;
          font-weight: 500;
          box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3);
          display: flex;
          align-items: flex-start;
          gap: 1rem;
        }

        .warning-icon {
          width: 24px;
          height: 24px;
          flex-shrink: 0;
          margin-top: 0.1rem;
        }

        .info-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 1.5rem;
          margin: 2rem 0;
        }

        .info-card {
          background: #EEEEEE;
          padding: 1.5rem;
          border-radius: 12px;
          border-left: 4px solid #FFD369;
          transition: all 0.3s ease;
        }

        .info-card:hover {
          background: #FFD369;
          color: #222831;
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(255, 211, 105, 0.3);
        }

        .info-card-header {
          display: flex;
          align-items: center;
          margin-bottom: 1rem;
        }

        .info-card-icon {
          width: 24px;
          height: 24px;
          margin-right: 0.75rem;
          color: #393E46;
        }

        .info-card:hover .info-card-icon {
          color: #222831;
        }

        .info-card-title {
          font-weight: 600;
          font-size: 1.1rem;
          margin: 0;
        }

        .contact-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 1.5rem;
          margin-top: 2rem;
        }

        .contact-item {
          display: flex;
          align-items: center;
          padding: 1rem;
          background: #EEEEEE;
          border-radius: 10px;
          transition: background 0.3s ease;
        }

        .contact-item:hover {
          background: #FFD369;
          color: #222831;
        }

        .contact-icon {
          width: 20px;
          height: 20px;
          margin-right: 0.75rem;
          color: #393E46;
        }

        .contact-item:hover .contact-icon {
          color: #222831;
        }
        .sub-section {
          margin: 1.5rem 0;
        }

        .sub-section-title {
          font-weight: 600;
          color: #222831;
          margin-bottom: 0.5rem;
          font-size: 1.1rem;
        }

        @media (max-width: 768px) {
          .company-name {
            font-size: 2rem;
          }
          
          .container {
            padding: 2rem 1rem;
          }
          
          .intro-section,
          .section {
            padding: 2rem;
          }
          
          .section-header {
            flex-direction: column;
            align-items: flex-start;
          }
          
          .section-icon {
            margin-bottom: 0.5rem;
          }
          
          .info-grid,
          .contact-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <header className="header">
        <div className="header-content">
          <Scale className="header-icon" />
          <h1 className="company-name">Gladious Constructions</h1>
          <p className="company-tagline">Clear Terms, Solid Foundations</p>
        </div>
      </header>

      <div className="container">
        <section className="intro-section">
          <div className="intro-content">
            <div className="last-updated">Last Updated: June 13, 2025</div>
            <h2 style={{ color: '#222831', fontSize: '2rem', marginBottom: '1rem' }}>
              Terms and Conditions
            </h2>
            <p>
              Welcome to Gladious Constructions. These Terms and Conditions ("Terms") govern your 
              relationship with Gladious Constructions ("Company", "we", "us", or "our") and your 
              use of our construction services, website, and related offerings. By engaging our 
              services or using our website, you agree to comply with and be bound by these Terms.
            </p>
            <div className="warning-box">
              <AlertTriangle className="warning-icon" />
              <div>
                <strong>Important:</strong> Please read these Terms carefully before using our services. 
                These Terms contain important information about your rights and obligations, including 
                limitations of liability and dispute resolution procedures.
              </div>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="section-header">
            <CheckCircle className="section-icon" />
            <h3 className="section-title">Acceptance of Terms</h3>
          </div>
          <div className="section-content">
            <p>By accessing our website, requesting a quote, signing a contract, or engaging our services, you acknowledge that you have read, understood, and agree to be bound by these Terms and our Privacy Policy.</p>
            <ul>
              <li>These Terms apply to all visitors, users, and customers</li>
              <li>Additional terms may apply to specific services or projects</li>
              <li>We reserve the right to refuse service to anyone for any reason</li>
              <li>Your continued use of our services constitutes acceptance of any updates to these Terms</li>
            </ul>
          </div>
        </section>

        <section className="section">
          <div className="section-header">
            <Building className="section-icon" />
            <h3 className="section-title">Services Overview</h3>
          </div>
          <div className="section-content">
            <p>Gladious Constructions provides comprehensive construction services including:</p>
            <div className="info-grid">
              <div className="info-card">
                <div className="info-card-header">
                  <Hammer className="info-card-icon" />
                  <h4 className="info-card-title">Residential Construction</h4>
                </div>
                <p>Custom homes, renovations, additions, and residential repairs</p>
              </div>
              <div className="info-card">
                <div className="info-card-header">
                  <Building className="info-card-icon" />
                  <h4 className="info-card-title">Commercial Construction</h4>
                </div>
                <p>Office buildings, retail spaces, warehouses, and commercial renovations</p>
              </div>
              <div className="info-card">
                <div className="info-card-header">
                  <FileText className="info-card-icon" />
                  <h4 className="info-card-title">Project Management</h4>
                </div>
                <p>Full project oversight, scheduling, and coordination services</p>
              </div>
              <div className="info-card">
                <div className="info-card-header">
                  <Users className="info-card-icon" />
                  <h4 className="info-card-title">Consultation Services</h4>
                </div>
                <p>Design consultation, feasibility studies, and construction advice</p>
              </div>
            </div>
            <div className="highlight-box">
              All services are subject to availability, licensing requirements, and applicable local regulations.
            </div>
          </div>
        </section>

        <section className="section">
          <div className="section-header">
            <FileText className="section-icon" />
            <h3 className="section-title">Project Contracts and Agreements</h3>
          </div>
          <div className="section-content">
            <div className="sub-section">
              <h4 className="sub-section-title">Contract Formation</h4>
              <ul>
                <li>All projects require a signed written contract</li>
                <li>Contracts become binding upon signature by both parties</li>
                <li>Verbal agreements are not legally binding</li>
                <li>Contracts must include detailed scope, timeline, and pricing</li>
              </ul>
            </div>
            
            <div className="sub-section">
              <h4 className="sub-section-title">Scope of Work</h4>
              <ul>
                <li>Work will be performed according to contract specifications</li>
                <li>Changes to scope require written approval and may affect pricing</li>
                <li>Additional work outside the original scope will be charged separately</li>
                <li>We reserve the right to refuse unreasonable change requests</li>
              </ul>
            </div>

            <div className="sub-section">
              <h4 className="sub-section-title">Project Timeline</h4>
              <ul>
                <li>Timelines are estimates and may be affected by weather, permits, or unforeseen circumstances</li>
                <li>We will make reasonable efforts to meet agreed-upon deadlines</li>
                <li>Delays caused by client decisions or actions are not our responsibility</li>
                <li>Force majeure events may extend project timelines without penalty</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="section-header">
            <DollarSign className="section-icon" />
            <h3 className="section-title">Pricing and Payment Terms</h3>
          </div>
          <div className="section-content">
            <div className="sub-section">
              <h4 className="sub-section-title">Pricing Structure</h4>
              <ul>
                <li>All prices are quoted in USD unless otherwise specified</li>
                <li>Quotes are valid for 30 days unless otherwise stated</li>
                <li>Final pricing may vary due to material costs or project changes</li>
                <li>We reserve the right to adjust pricing for long-term projects</li>
              </ul>
            </div>

            <div className="sub-section">
              <h4 className="sub-section-title">Payment Schedule</h4>
              <ol>
                <li><strong>Down Payment:</strong> 25% due upon contract signing</li>
                <li><strong>Progress Payments:</strong> Invoiced based on project milestones</li>
                <li><strong>Final Payment:</strong> Due within 30 days of project completion</li>
                <li><strong>Late Fees:</strong> 1.5% per month on overdue balances</li>
              </ol>
            </div>

            <div className="highlight-box">
              <strong>Payment Methods:</strong> We accept cash, check, bank transfer, and major credit cards. 
              A 3% processing fee applies to credit card payments over $5,000.
            </div>

            <div className="warning-box">
              <AlertTriangle className="warning-icon" />
              <div>
                <strong>Important:</strong> Work may be suspended if payments become 15 days overdue. 
                We reserve the right to place a lien on the property for unpaid balances.
              </div>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="section-header">
            <Shield className="section-icon" />
            <h3 className="section-title">Insurance and Liability</h3>
          </div>
          <div className="section-content">
            <div className="sub-section">
              <h4 className="sub-section-title">Our Insurance Coverage</h4>
              <ul>
                <li>General liability insurance: $2,000,000 per occurrence</li>
                <li>Workers' compensation insurance for all employees</li>
                <li>Professional liability insurance for design services</li>
                <li>Commercial auto insurance for company vehicles</li>
              </ul>
            </div>

            <div className="sub-section">
              <h4 className="sub-section-title">Client Responsibilities</h4>
              <ul>
                <li>Maintain property insurance during construction</li>
                <li>Notify your insurance company of construction activities</li>
                <li>Ensure adequate coverage for the increased property value</li>
                <li>Report any damages or incidents immediately</li>
              </ul>
            </div>

            <div className="sub-section">
              <h4 className="sub-section-title">Limitation of Liability</h4>
              <p>Our liability is limited to the contract value of the specific project. We are not liable for:</p>
              <ul>
                <li>Consequential or indirect damages</li>
                <li>Loss of use or business interruption</li>
                <li>Damages exceeding the project contract value</li>
                <li>Issues arising from client-provided materials or designs</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="section-header">
            <Clock className="section-icon" />
            <h3 className="section-title">Warranties and Guarantees</h3>
          </div>
          <div className="section-content">
            <div className="sub-section">
              <h4 className="sub-section-title">Workmanship Warranty</h4>
              <ul>
                <li><strong>Structural Work:</strong> 2 years from completion</li>
                <li><strong>General Construction:</strong> 1 year from completion</li>
                <li><strong>Finishes and Fixtures:</strong> 90 days from completion</li>
                <li><strong>Repairs and Touch-ups:</strong> 30 days from completion</li>
              </ul>
            </div>

            <div className="sub-section">
              <h4 className="sub-section-title">Material Warranties</h4>
              <ul>
                <li>Manufacturer warranties apply to all materials and equipment</li>
                <li>We will assist with warranty claims during the first year</li>
                <li>Defective materials will be replaced at no charge during warranty period</li>
                <li>Client is responsible for manufacturers' warranty procedures after one year</li>
              </ul>
            </div>

            <div className="sub-section">
              <h4 className="sub-section-title">Warranty Exclusions</h4>
              <ul>
                <li>Normal wear and tear</li>
                <li>Damage from misuse or negligence</li>
                <li>Issues arising from lack of proper maintenance</li>
                <li>Modifications made by others</li>
                <li>Acts of nature or force majeure events</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="section-header">
            <Users className="section-icon" />
            <h3 className="section-title">Client Responsibilities</h3>
          </div>
          <div className="section-content">
            <div className="sub-section">
              <h4 className="sub-section-title">Site Preparation</h4>
              <ul>
                <li>Provide clear and safe access to the work site</li>
                <li>Remove or protect personal property as needed</li>
                <li>Ensure utilities are clearly marked and accessible</li>
                <li>Obtain necessary permits (unless specified in contract)</li>
              </ul>
            </div>

            <div className="sub-section">
              <h4 className="sub-section-title">Communication and Decisions</h4>
              <ul>
                <li>Respond to requests for decisions within reasonable timeframes</li>
                <li>Designate a primary contact person for the project</li>
                <li>Attend scheduled meetings and inspections</li>
                <li>Review and approve plans, materials, and changes promptly</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="section-header">
            <AlertTriangle className="section-icon" />
            <h3 className="section-title">Safety and Compliance</h3>
          </div>
          <div className="section-content">
            <div className="sub-section">
              <h4 className="sub-section-title">Safety Standards</h4>
              <ul>
                <li>All work complies with OSHA safety regulations</li>
                <li>Workers are trained in proper safety procedures</li>
                <li>Personal protective equipment is required on all sites</li>
                <li>Safety violations will result in immediate work stoppage</li>
              </ul>
            </div>

            <div className="sub-section">
              <h4 className="sub-section-title">Building Codes and Permits</h4>
              <ul>
                <li>All work meets or exceeds local building codes</li>
                <li>Required inspections will be scheduled and completed</li>
                <li>Permit fees are typically included in project costs</li>
                <li>Code violations discovered during work will be corrected</li>
              </ul>
            </div>

            <div className="highlight-box">
              <strong>Site Safety:</strong> Client and visitors enter construction sites at their own risk. 
              Hard hats and safety equipment may be required in active work areas.
            </div>
          </div>
        </section>

        <section className="section">
          <div className="section-header">
            <Scale className="section-icon" />
            <h3 className="section-title">Dispute Resolution</h3>
          </div>
          <div className="section-content">
            <div className="sub-section">
              <h4 className="sub-section-title">Resolution Process</h4>
              <ol>
                <li><strong>Direct Communication:</strong> Attempt to resolve issues through direct discussion</li>
                <li><strong>Mediation:</strong> Engage a neutral third-party mediator if needed</li>
                <li><strong>Arbitration:</strong> Binding arbitration through the American Arbitration Association</li>
                <li><strong>Legal Action:</strong> Court proceedings as last resort (subject to jurisdiction clauses)</li>
              </ol>
            </div>

            <div className="sub-section">
              <h4 className="sub-section-title">Governing Law</h4>
              <ul>
                <li>These Terms are governed by the laws of [Your State/Province]</li>
                <li>Disputes will be resolved in courts of [Your City/County]</li>
                <li>Statutory lien rights are reserved under applicable law</li>
                <li>Time limitations for claims begin at project completion</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="section-header">
            <FileText className="section-icon" />
            <h3 className="section-title">Cancellation and Termination</h3>
          </div>
          <div className="section-content">
            <div className="sub-section">
              <h4 className="sub-section-title">Client Cancellation Rights</h4>
              <ul>
                <li><strong>Before Work Begins:</strong> 3-day cancellation period with full refund minus administrative fees</li>
                <li><strong>After Work Begins:</strong> Client pays for completed work plus 15% of remaining contract value</li>
                <li><strong>Materials Ordered:</strong> Client responsible for materials ordered specifically for the project</li>
              </ul>
            </div>

            <div className="sub-section">
              <h4 className="sub-section-title">Company Termination Rights</h4>
              <p>We may terminate contracts for:</p>
              <ul>
                <li>Non-payment of invoices</li>
                <li>Breach of contract terms</li>
                <li>Unsafe site conditions</li>
                <li>Unreasonable client behavior or demands</li>
                <li>Discovery of undisclosed site conditions making work impossible</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="section-header">
            <Mail className="section-icon" />
            <h3 className="section-title">Contact Information</h3>
          </div>
          <div className="section-content">
            <p>
              For questions about these Terms and Conditions or any legal matters related to our services, 
              please contact us:
            </p>
            <div className="contact-grid">
              <div className="contact-item">
                <Mail className="contact-icon" />
                <span>legal@gladiousconstructions.com</span>
              </div>
              <div className="contact-item">
                <Phone className="contact-icon" />
                <span>+1 (555) 123-4567</span>
              </div>
              <div className="contact-item">
                <MapPin className="contact-icon" />
                <span>123 Construction Ave, Builder City, BC 12345</span>
              </div>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="section-header">
            <Clock className="section-icon" />
            <h3 className="section-title">Updates to Terms</h3>
          </div>
          <div className="section-content">
            <p>
              We reserve the right to update these Terms and Conditions at any time. Changes will be effective immediately upon posting on our website. We will notify clients of material changes through:
            </p>
            <ul>
              <li>Email notification to active clients</li>
              <li>Posted notice on our website</li>
              <li>Written notice for ongoing projects</li>
              <li>Inclusion in new contract documents</li>
            </ul>
            <div className="highlight-box">
              Your continued use of our services after any changes constitutes acceptance of the updated Terms.
            </div>
          </div>
        </section>
      </div>
    </div>
    </>
  );
};

export default TermsConditions;